import React, {useEffect, useState} from "react";
import {initialNoActionFormData} from "./AddEditModal";
import TextField from "@mui/material/TextField";
import {WaitTimeInput} from "../WaitTimeInput";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {DialogActions, DialogContent} from "@mui/material";
import {ErrorMessage} from "../../common/ErrorMessage";
import {useMutation} from "@apollo/client";
import {CREATE_NO_ACTION_STAGE} from "../../../api/stage/createNoActionStage";
import {NoActionStage} from "../../../api/stage/getStages";
import {UPDATE_STAGE} from "../../../api/stage/updateStage";

type NoActionFormProps = {
    formData: NoActionStage
    onClose: (shouldRefetch: boolean) => void,
    setLoading: (nextValue: boolean) => void,
    updateFormData: (newValues: Partial<typeof initialNoActionFormData>) => void,
}

export const NoActionForm = (props: NoActionFormProps) => {
    const {formData, onClose, setLoading, updateFormData} = props

    const [snackBarMessage, setSnackBarMessage] = useState('')

    const [createNoActionStage, {error: createError}] = useMutation(CREATE_NO_ACTION_STAGE)
    const [updateStage, {error: updateError}] = useMutation(UPDATE_STAGE)

    const onSubmit = async () => {
        setLoading(true)

        if (formData.id === '') {
            const {errors} = await createNoActionStage({variables: {input: {
                title: formData.title,
                description: formData.description,
                waitTime: formData.waitTime,
            }}})

            if (errors === undefined || errors.length === 0) {
                setSnackBarMessage('')
                onClose(true)
            }
        } else {
            const {errors} = await updateStage({variables: {input: {
                description: formData.description,
                id: formData.id,
                title: formData.title,
                type: formData.type,
                waitTime: formData.waitTime,
            }}})

            if (errors === undefined || errors.length === 0) {
                setSnackBarMessage('')
                onClose(true)
            }
        }

        setLoading(false)
    }

    useEffect(() => {
        if (createError) setSnackBarMessage(createError.message)
        else if (updateError) setSnackBarMessage(updateError.message)
    }, [createError?.message, updateError?.message])

    return (
        <>
            <DialogContent>
                <Stack gap="1.5rem">
                    <TextField
                        label="Title"
                        onChange={(e) => updateFormData({title: e.target.value})}
                        value={formData.title}
                        variant="outlined"
                    />

                    <TextField
                        label="Description"
                        minRows={3}
                        multiline
                        onChange={(e) => updateFormData({description: e.target.value})}
                        value={formData.description}
                        variant="outlined"
                    />

                    <WaitTimeInput
                        initialValue={formData.waitTime}
                        onChange={(nextValue: number) => updateFormData({waitTime: nextValue})}
                    />
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => onClose(false)}
                    variant="contained"
                    color="error"
                >
                    Close
                </Button>
                <Button
                    color="success"
                    disabled={formData.title === '' || formData.description === '' || formData.waitTime === 0}
                    onClick={onSubmit}
                    variant="contained"
                >
                    {formData.id === '' ? 'Add' : 'Edit'}
                </Button>
            </DialogActions>

            <ErrorMessage
                handleClose={() => setSnackBarMessage('')}
                isOpen={snackBarMessage !== ''}
                message={snackBarMessage}
            />
        </>
    )
}
